import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgStarIconSecondary from './svgs/StarIconSecondary.js';
import SvgStarIcon from './svgs/StarIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var starIcon = (props => useIcon(SvgStarIcon, SvgStarIconSecondary, props));

export { starIcon as default };
